import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "className", "error"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Field.scss';

var TextField = function TextField(_ref) {
  var name = _ref.name,
      className = _ref.className,
      error = _ref.error,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames('Field TextField', {
      error: !!error
    })
  }, /*#__PURE__*/React.createElement("input", _extends({
    id: name,
    type: "text"
  }, inputProps)));
};

TextField.propTypes = {
  name: PropTypes.string,
  className: PropTypes.object,
  error: PropTypes.object,
  placeholder: PropTypes.string
};
export default TextField;